import {guid} from '../../util/GuidUtil';

const idReducer = (state = guid()) => {
    return state;
};

export default idReducer;